// extracted by mini-css-extract-plugin
module.exports = {"header":"AddDiscountModal_header_2HioB","wrapper":"AddDiscountModal_wrapper_Mf8xM","controls":"AddDiscountModal_controls_2Wane"};